import { useState, useEffect } from "react";
import { GlobalProvider, useGlobal } from "../contexts/GlobalContext";

function Hero() {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [coverImage, setCoverImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { t, parse, i18n, iUrl } = useGlobal();

  // Fetch cover image from Directus
  useEffect(() => {
    const fetchCoverImage = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${import.meta.env.VITE_DIRECTUS_PUBLIC_URL}/items/cover_image`);
        const data = await response.json();

        if (data.data) {
          setCoverImage(data.data.cover_image);
        }
      } catch (error) {
        console.error("Cover image fetch error:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCoverImage();
  }, []);
  // Cover Text fetch from Directus and random pick
  const coversTextArray = t("cover_text", "WELCOME TO LA LEPRE", {
    returnObjects: true,
  });
  const randomCoverArray = coversTextArray?.length > 0 ? coversTextArray[Math.floor(Math.random() * coversTextArray.length)]: null;
  const randomCoverText = randomCoverArray?.cover_text
  return (
    <section className="hero relative w-full h-screen overflow-hidden bg-black">
      {/* Background Image */}
      {coverImage && (
        <img
          src={`${iUrl}${coverImage}?format=webp`}
          alt="Hero background"
          className={`hero__background-image absolute inset-0 w-full h-full object-cover transition-opacity duration-2000 ease-out ${
            imageLoaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setImageLoaded(true)}
        />
      )}

      {/* Color Overlay */}
      <div className="hero__overlay absolute inset-0 bg-secondary-500/60"></div>

      {/* Content Layer */}
      <div className="hero__content-wrapper relative z-10 flex items-center justify-center h-full">
        <div className="hero__content text-left text-white px-4">
          <h1
            className={`hero__title font-display text-left font-extralight leading-16 md:leading-32 text-4xl md:text-8xl transition-opacity duration-2000 ease-out ${
              imageLoaded ? "opacity-100" : "opacity-0"}`}
          >
            {parse(randomCoverText)}
          </h1>

          <p className="hero__subtitle font-body text-xl md:text-2xl max-w-2xl mx-auto leading-relaxed"></p>
        </div>
      </div>
    </section>
  );
}

export default Hero;
